export enum AvailableCurrencies {
  ARS = 'ARS',
  CLP = 'CLP',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  CNY = 'CNY',
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  SEK = 'SEK',
  NOK = 'NOK',
  DKK = 'DKK',
  NZD = 'NZD',
  MXN = 'MXN',
  BRL = 'BRL',
  INR = 'INR',
  RUB = 'RUB',
  ZAR = 'ZAR',
  TRY = 'TRY',
  AED = 'AED',
  HKD = 'HKD',
  SGD = 'SGD',
  KRW = 'KRW',
  TWD = 'TWD',
  MYR = 'MYR',
  PHP = 'PHP',
  THB = 'THB',
  VND = 'VND',
  IDR = 'IDR',
  PLN = 'PLN',
  HUF = 'HUF',
  CZK = 'CZK',
  BGN = 'BGN',
  RON = 'RON',
  HRK = 'HRK',
  ISK = 'ISK',
  LVL = 'LVL',
  LTL = 'LTL',
  EEK = 'EEK',
  MTL = 'MTL',
  CYP = 'CYP',
}
